const user = {
    namespaced: true,
    state: {
        historySearchList:[],  // 搜索历史
        myCarList:[],  // 购物车列表
        isSettingInterest:false, // 用于控制兴趣爱好弹框是否弹过
        selectCourseType:'',  // 用于获取选中的课程类型
        isFirstLearning:false,  // 用于控制学习流程指引是否弹出
        relationshipOptions:[],  // 家庭关系列表
    },
    getters: {

    },
    mutations: {
        /**搜索历史 */
        setHistorySearchList(state,value){
            let index = state.historySearchList.findIndex(item=>item==value);
            if(index != -1){
                state.historySearchList.splice(index,1);
            }
            state.historySearchList.unshift(value);
        },
        /**清空搜索历史 */
        setEmptyHistorySearchList(state,value){
            if(!value.length){
                state.historySearchList = [];
            }
        },
        /**购物车列表 */
        setMyCarList(state,value){
            state.myCarList = value;
        },
        /** 控制兴趣爱好弹框是否弹过(弹过则不需要再次弹出)  */
        setIsSettingInterest(state,value){
            state.isSettingInterest = value;
        },
        /** 用于获取选中的课程类型 */
        setSelectCourseType(state,value){
            state.selectCourseType = value;
        },
        /** 用于控制学习流程指引是否弹出 */
        setIsFirstLearning(state,value){
            state.isFirstLearning = value;
        },
        /** 家庭关系列表 */
        setRelationshipOptions(state,value){
            state.relationshipOptions = value;
        }
    },
    actions: {}
}
export default user